export default "__VITE_ASSET__DudM4anU__"